import { render, staticRenderFns } from "./user-photos-slide.vue?vue&type=template&id=7d8bc521"
import script from "./user-photos-slide.vue?vue&type=script&lang=js"
export * from "./user-photos-slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports